'use strict';

function CompanyCustomerServiceService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/services', {}, {});
}

angular.module('dokiv')
  .factory('CompanyCustomerServiceService', ['$resource', 'config', CompanyCustomerServiceService]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-service/CompanyCustomerServiceService.js
// module id = 333
// module chunks = 0